import { computed, Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {

  private readonly show = signal<boolean>(false);
  _loaderOpened = computed(() => this.show());

  open() {
    this.show.set(true);
  }

  close() {
    this.show.set(false);
  }

}
